export function normalizeKeycloakAuthority(authority?: string | null): string {
  return (authority || '').trim().replace(/\/+$/, '');
}
